<template>
  <div class="task_pop_bg">
    <!-- 标题 -->
    <div class="topSpot"></div>
    <div class="bottomSpot"></div>
    <div class="topBorder"></div>
    <div class="titleLine">
      <div class="info_title">
        <div class="titleLine_name">
          <span class="leftLine"></span
          ><span style="color: #2ac1ff">任务详情</span>
        </div>
        <div class="closeBtn" @click="closeTaskDetail"></div>
      </div>
    </div>
    <div class="middleOutLine">
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="80px"
      >
        <!-- <div class="notisfy">关联消息：{{resultData.level|getlevelName}}</div> -->
        <el-form-item label="任务标题">
          <el-input v-model="ruleForm.TaskTiltle" disabled></el-input>
        </el-form-item>
        <el-form-item label="任务内容" prop="TaskDesc">
          <el-input
            type="textarea"
            v-model="ruleForm.TaskDesc"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-input v-model="ruleForm.TaskStatusName" disabled></el-input>
        </el-form-item>
        <el-form-item label="责任人">
          <el-input v-model="ruleForm.Creater" disabled></el-input>
        </el-form-item>
        <el-form-item label="地址">
          <el-input v-model="ruleForm.Location" disabled></el-input>
        </el-form-item>
        <el-form-item label="坐标">
          <el-input v-model="ruleForm.zuobiao" disabled></el-input>
        </el-form-item>
        <div class="mapBox">
          <div class="map" id="allmap" style="width: 100%; height: 100%"></div>
          <div class="coverbg"></div>
        </div>
        <!-- <el-form-item label="截止时间">
          <el-input v-model="ruleForm.name" disabled></el-input>
        </el-form-item> -->
        <!-- <div
          class="notisfy"
          v-if="ruleForm.TaskStatus == '2' || ruleForm.TaskStatus == '4'"
        >
          完成说明:
        </div> -->
        <el-form-item label="完成说明" v-if="ruleForm.TaskStatus == '2'">
          <el-input
            v-model="FinishDesc"
            disabled
            type="textarea"
            :rows="2"
          ></el-input>
        </el-form-item>

        <el-form-item label="图片" v-if="FeedAttachImgList.length > 0">
          <el-image
            v-for="(ele, index) in FeedAttachImgList"
            :key="index"
            v-bind:src="ele.FileUrl"
            style="width: 100px; height: 130px; padding-right: 10px"
            :preview-src-list="getPreviewImgList(index)"
          />
        </el-form-item>
        <el-form-item
          label="视频"
          v-if="FeedAttachVideoList.length > 0"
          style="text-align: left"
        >
          <video
            v-for="(ele, index) in FeedAttachVideoList"
            :key="index"
            controls
            style="width: 300px; height: 150px; margin-bottom: 10px"
          >
            <source v-bind:src="ele.FileUrl" type="video/mp4" />
            <source v-bind:src="ele.FileUrl" type="video/ogg" />
            Your browser does not support the video tag.
          </video>
        </el-form-item>

        <el-form-item
          label="关闭时间"
          v-if="ruleForm.TaskStatus == '2' || ruleForm.TaskStatus == '4'"
        >
          <el-input v-model="ruleForm.ModifyTime" disabled></el-input>
        </el-form-item>
        <el-form-item
          label="关闭人"
          v-if="ruleForm.TaskStatus == '2' || ruleForm.TaskStatus == '4'"
        >
          <el-input v-model="ruleForm.ChargerName" disabled></el-input>
        </el-form-item>
        <el-form-item
          label="关闭原因"
          v-if="show || ruleForm.TaskStatus == '4'"
        >
          <el-input v-model="ruleForm.memo"></el-input>
        </el-form-item>
        <el-form-item
          style="margin-top: 10px; display: flex; justify-content: flex-end"
          v-if="show"
        >
          <el-button @click="closeTask()">确认关闭</el-button>
        </el-form-item>
        <el-form-item
          v-if="
            !show && (ruleForm.TaskStatus == '0' || ruleForm.TaskStatus == '1')
          "
        >
          <div style="text-align: right">
            <el-button @click="showClosebtn()">关闭任务</el-button>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <div class="bottomBorder"></div>
  </div>
</template>
<script>
import MyApis from "../../../apis";
import fedbackApis from "../../../../../emergency/src/apis";
import ZJApp from "../../../../../app";
import waitAll from "../../../../../../utils/src/waitAll";
import { handleMsg, getMsgInfo } from "../../../../../../request/msgApi";
import { mapGetters, mapState } from "vuex";
export default {
  data() {
    return {
      ruleForm: {
        TaskTiltle: "",
        TaskDesc: "",
        TaskStatus: "",
        TaskStatusName: "",
        Location: "",
        Creater: "",
        zuobiao: "",
        Location: "",
        ChargerName: "",
        ModifyTime: "",
        memo: "",
        FeedbackDesc: null,
      },
      rules: {
        memo: [{ required: true, message: "请输入内容", trigger: "blur" }],
      },
      IsEdit: false,
      dialogImageUrl: "",
      dialogVisible: false,
      disabled: false,
      imgList: [],
      fileList: [],
      delFileList: [],
      currentValue: "",
      preValue: "",
      resultData: {},
      handleStatus: false, //false为待处理，true为已处理
      detailData: {},
      show: false,
      center: [],
      center2: [],
      isHavePosition: false,
      FeedAttachList: [],
      FeedAttachImgList: [],
      FeedAttachVideoList: [],
      FinishDesc: "",
    };
  },
  filters: {
    getlevelName(val) {
      if (val == "warning_level_1") {
        return "一级";
      } else if (val == "warning_level_2") {
        return "二级";
      } else if (val == "warning_level_3") {
        return "三级";
      }
    },
  },
  props: {
    ExecutTaskId: {
      type: String,
      default: "",
    },
    isLookDetails: {
      type: Boolean,
      default: false,
    },
  },
  created: function () {
    if (this.isLookDetails) {
      this.getTaskDetails();
      this.GetFeedBack();
    }
  },
  mounted: function () {},
  methods: {
    showClosebtn() {
      this.show = true;
    },
    getPreviewImgList(index) {
      let arr = [];
      for (let i = 0; i < this.FeedAttachImgList.length; i++) {
        arr.push(this.FeedAttachImgList[i + index].FileUrl);
        if (i + index >= this.FeedAttachImgList.length - 1) {
          index = 0 - (i + 1);
        }
      }
      return arr;
    },
    getTaskDetails() {
      let that = this;
      let params = {
        ExecutTaskId: this.ExecutTaskId,
      };
      that.center = [];
      new MyApis.ExecutTaskApi()
        .GetItemById(params)
        .then((r) => {
          console.log("任务详情");
          console.log(r);
          let data = r.data.Data;
          that.detailData = data;
          if (data.TaskStatus == "0") {
            that.ruleForm.TaskStatusName = "未处理";
          } else if (data.TaskStatus == "1") {
            that.ruleForm.TaskStatusName = "执行中";
          } else if (data.TaskStatus == "2") {
            that.ruleForm.TaskStatusName = "已完成";
          } else if (data.TaskStatus == "3") {
            that.ruleForm.TaskStatusName = "异常";
          } else if (data.TaskStatus == "4") {
            that.ruleForm.TaskStatusName = "关闭";
          }
          that.ruleForm.TaskTiltle = data.TaskTiltle;
          that.ruleForm.TaskDesc = data.TaskDesc;
          that.ruleForm.Creater = data.Creater;
          that.ruleForm.zuobiao = data.Longitude + "," + data.Latitude;
          that.ruleForm.TaskDesc = data.TaskDesc;
          that.ruleForm.TaskStatus = data.TaskStatus;
          that.ruleForm.ChargerName = data.ChargerName;
          that.ruleForm.memo = data.Memo;
          if (data.Memo) {
            that.FinishDesc = data.Memo;
          }

          that.ruleForm.ModifyTime = new Date(data.ModifyTime).format(
            "yyyy-MM-dd hh:mm:ss"
          );
          that.ruleForm.Location = data.Location;
          if (data.Longitude & data.Latitude) {
            that.isHavePosition = true;
            that.center.push(data.Longitude);
            that.center.push(data.Latitude);
          }

          that.onDrawMap();
        })
        .catch((e) => {
          console.error(e);
          that.$message({
            message: e.RspMsg ? e.RspMsg : "下发任务失败！",
            type: "error",
          });
        });
    },
    //获取任务反馈
    GetFeedBack() {
      let that = this;
      let ExecutTaskSearch = {
        ExecutTaskId: this.ExecutTaskId,
        Validity: 1,
      };

      that.FeedAttachImgList = [];
      that.FeedAttachVideoList = [];
      new fedbackApis.ExecutFeedbackApi()
        .FindByConditions(ExecutTaskSearch)
        .then((r) => {
          r = r.data.Data;
          if (r && r.length > 0) {
            that.ruleForm.FeedbackDesc = r[0].FeedbackDesc;
            if (r[0].FeedbackDesc) {
              that.FinishDesc = r[0].FeedbackDesc;
            }
            that.FeedAttachList = r[0].FeedAttachList;
          }
          if (r && r.length > 0) {
            r[0].FeedAttachList.forEach((item) => {
              if (that.isImage(item.FileType)) {
                item.src = item.FileUrl;
                item.id = item.id;
                that.FeedAttachImgList.push(item);
              }
              if (that.isVideo(item.FileType)) {
                item.src = item.FileUrl;
                item.id = item.id;
                that.FeedAttachVideoList.push(item);
              }
            });
            console.log(
              "图片视频",
              that.FeedAttachImgList,
              that.FeedAttachVideoList
            );
          }
        })
        .catch((e) => {
          that.$message({
            message: e.RspMsg ? e.RspMsg : "加载反馈列表异常！",
            type: "error",
          });
        });
    },
    closeTaskDetail() {
      this.$emit("closeTaskDetail", false);
    },
    closeTask() {
      let that = this;
      let params = {
        ExecutTaskId: that.ExecutTaskId,
        Id: that.detailData.Id,
        Creater: that.detailData.Creater,
        CreateTime: that.detailData.CreateTime,
        Modifier: ZJApp.ZJUser.current.UserName,
        ModifyTime: new Date(),
        Validity: 1,
        Extend1: that.detailData.Extend1,
        Extend2: that.detailData.Extend2,
        OrgId: that.detailData.OrgId,
        TaskId: that.detailData.TaskId,
        PlanId: that.detailData.PlanId,
        ExecutId: "newtaskfortaskcenter",
        TaskTypeId: that.detailData.TaskTypeId,
        TaskTiltle: that.detailData.TaskTiltle,
        TaskDesc: that.detailData.TaskDesc,
        ChargerId: that.detailData.ChargerId,
        ChargerName: that.detailData.ChargerName,
        Phone: that.detailData.Phone,
        PlanResponseTime: that.detailData.PlanResponseTime,
        ExecWay: that.detailData.ExecWay,
        PlanResourceId: that.detailData.PlanResourceId,
        OrderNo: that.detailData.OrderNo,
        Memo: that.ruleForm.memo,
        TaskStatus: "4", //2-已完成   1-未完成
        ErrorMsg: that.detailData.ErrorMsg,
        Location: that.detailData.Location,
        Longitude: that.detailData.Longitude,
        Latitude: that.detailData.Latitude,
        ListReceiver: that.detailData.ListReceiver,
        ListResuorseTeam: that.detailData.ListResuorseTeam,
        ListAdressBook: that.detailData.ListAdressBook,
        ListMaterials: that.detailData.ListMaterials,
        ListOrganiztion: that.detailData.ListOrganiztion,
        ListWareHouse: that.detailData.ListWareHouse,
      };
      new MyApis.ExecutTaskApi()
        .UpdateItem(params)
        .then((r) => {
          console.log("处理任务详情");
          console.log(r);
          let result = r.data.Data;
          if (result) {
            that.$emit("closeTaskDetail", false);
          }
        })
        .catch((e) => {
          console.error(e);
          that.$message({
            message: e.RspMsg ? e.RspMsg : "下发任务失败！",
            type: "error",
          });
        });
    },
    // 弹出一个错误消息
    errmsg(msg) {
      this.$message({
        showClose: true,
        message: msg || "",
        type: "error",
        customClass: "zj-login-msgbox",
      });
    },
    goCenter: function () {
      let that = this;
      // eslint-disable-next-line no-undef
      console.log("this.center");
      console.log(this.center);
      // if(this.center.length>0){
      // eslint-disable-next-line no-undef
      console.log("this.center");
      console.log(this.center);
      this.mapInstance.panTo(new BMap.Point(this.center[0], this.center[1]));
      that.addDom();
      // setTimeout(() => {
      //   if(that.isHavePosition){
      //     that.addDom();
      //   }else{
      //     that.addMarker(that.mapInstance,that.center)
      //   }

      // }, 1000);
      // }else{
      //   this.getMapCenter();
      //   setTimeout(() => {
      //     // eslint-disable-next-line no-undef
      //     this.mapInstance.panTo(new BMap.Point(this.center2[0], this.center2[1]));
      //     if(that.isHavePosition){
      //       that.addDom();
      //     }else{
      //       that.addMarker(that.mapInstance,that.center2)
      //     }
      //   }, 2000);
      // }
    },
    onDrawMap: function () {
      let center = this.center;
      var map = new BMap.Map("allmap");
      var point = new BMap.Point(center[0], center[1]);
      map.centerAndZoom(point, 15);
      var marker = new BMap.Marker(point); // 创建标注
      map.addOverlay(marker); // 将标注添加到地图中
      marker.setAnimation(BMAP_ANIMATION_BOUNCE); //跳动的动画

      // 创建地图，并通过样式让地图填满窗口
      // let that = this;
      // this.$nextTick(function() {
      //   // eslint-disable-next-line no-undef
      //   $(function() {
      //     // 不传入 syscode 和 key ，或者值为空时，
      //     // zjumap 插件自动从 URL 地址
      //     // http://HOST:PORT/Areas/Map/Content/UMap.html?syscode=xxx&key=yyy
      //     // 中读取 syscode 和 key 的值。
      //     // eslint-disable-next-line no-undef
      //     $(".map").zjumap({
      //       syscode: "ZJMap",
      //       key: "EmergencyOneMap",
      //       loading: ".global-loading",
      //       loadingText: ".global-loading-text",
      //       //地图配置
      //       mapConfigs: {
      //         mapStyle: "",
      //         togglePanelVisiable: false,
      //         mapLayers: "DOM",
      //         clickToShowLocation: false,
      //         // reportGeo: true,
      //         // onGotGeo: function(e) {
      //         //   e.handled = true;
      //         //   if (that.marker) {
      //         //     that.marker.setPosition(
      //         //       e.map.newPoint(e.point.lng, e.point.lat)
      //         //     );
      //         //   } else {
      //         //     that.marker = that.addMarker(e.map, e.point);
      //         //   }
      //         //   that.dialogVisible2 = true;
      //         //   that.lat = e.point.lat;
      //         //   that.lng = e.point.lng;
      //         // },
      //         onMapCreated: function(e) {
      //           console.log("e")
      //           console.log(e)
      //           console.log(e.map.getLayerByName("DOM"));
      //           that.mapInstance = e.map;
      //            console.log(that.mapInstance)
      //           // e.map.clearAll();
      //           that.center2 = e.map.config.center;
      //           that.goCenter();
      //           // setTimeout(() => {
      //           //   that.addDom();
      //           // }, 1000);

      //         }
      //       }
      //     });
      //   });
      // });
    },
    addMarker: function (map, point) {
      if (!map) return null;
      this.marker = map.createOverlay(
        point,
        {
          url: "/lib/zjmap/Content/images/noposition.png",
          width: 100,
          height: 75,
          offsetX: 24,
          offsetY: 48,
        },
        null,
        {
          enableClicking: false,
        }
      );
      map.addOverlay(this.marker);
      return this.marker;
    },
    addDom: function () {
      if (!this.mapInstance) return;
      // var layer = this.mapInstance.getLayerByName("DOM");
      this.ComplexCustomOverlay.prototype = new BMap.Overlay();
      this.ComplexCustomOverlay.prototype.initialize = function (map) {
        // var layer = this.mapInstance.addOverlay;
        // console.log('layer')
        // console.log(layer)
        // if (layer && layer.addDom)
        this._map = map;
        // eslint-disable-next-line no-undef
        var $div = $("<div></div>");
        $div.append(this.getSvgContent());
        $div.css({
          width: "30rem",
          height: "30rem",
          "margin-left": "-15rem",
          "margin-top": "-15rem",
          position: "absolute",
        });
        this.mapInstance.getPanes().labelPane.appendChild($div);

        return $div;
      };
      let center = this.center;
      var myCompOverlay = new this.ComplexCustomOverlay(
        new BMap.Point(center[0], center[1])
      );

      this.mapInstance.addOverlay(myCompOverlay);
      // var label = new BMap.Label($div,{offset:new BMap.Size(20,-10)});
      //   marker.setLabel(label);
      //   layer.addDom(this.center[0], this.center[1], $div[0]);
      // }
    },
    // 复杂的自定义覆盖物
    ComplexCustomOverlay(point, text, mouseoverText) {
      this._point = point;
      this._text = text;
      this._overText = mouseoverText;
    },
    getSvgContent: function () {
      var html =
        "" +
        '<div class="svg_container">' +
        '  <div class="svg-box">' +
        '     <svg version="1.1"  x="0px" y="0px" viewBox="0 0 100 100"' +
        '         enable-background="new 0 0 100 100" xml:space="preserve">' +
        '       <circle fill="rgba(244,16,11,5)" cx="50" cy="50" r="5" />' +
        '       <circle fill="rgba(244,16,11,0.2)" cx="50" cy="50" r="20" />' +
        '       <circle fill="rgba(244,16,11,0.1)" cx="50" cy="50" r="35" />' +
        "     </svg>" +
        "  </div>" +
        '  <div class="circle delay1"></div>' +
        '  <div class="circle delay2"></div>' +
        '  <div class="circle delay3"></div>' +
        "</div>";
      return html;
    },
    isImage: function (filename) {
      return ZJApp.ZJUtils.isImage(filename);
    },
    isVideo: function (filename) {
      return ZJApp.ZJUtils.isVideo(filename);
    },
  },
};
</script>
<style scoped lang="scss">
.task_pop_bg {
  width: 36.5%;
  position: fixed;
  left: 50%;
  top: 120px;
  z-index: 9999;
  margin-left: -18.2%;
  box-sizing: border-box;
  border-bottom-left-radius: 22px;
  .topBorder {
    width: 100%;
    // height:34px;
    // padding-top:64px;
    height: 34px;
    background: url("../../../../../../assets/pop_tz.png") no-repeat;
    background-size: 100% 34px;
    position: relative;
  }
  .bottomBorder {
    width: 100%;
    height: 25px;
    background: url("../../../../../../assets/pop_bz.png") no-repeat;
    background-size: 100%;
  }
  .titleLine {
    width: 100%;
    box-sizing: border-box;
    background: rgba(15, 36, 69, 0.8);
    border-left: 1px solid #2ac1ff;
    border-right: 1px solid #2ac1ff;
    padding-bottom: 10px;
    position: relative;
    .info_title {
      width: 92%;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px dashed #2ac1ff;
      padding-bottom: 10px;
    }
    .titleLine_name {
      display: flex;
      align-items: center;
      .leftLine {
        display: inline-block;
        width: 2px;
        height: 15px;
        margin-right: 10px;
        background: #2ac1ff;
      }
    }
    .closeBtn {
      width: 20px;
      height: 20px;
      background: url("../../../theme-default/src/img/close.png") no-repeat;
      background-size: 20px;
      position: absolute;
      right: 20px;
      top: 0px;
      z-index: 10;
    }
  }
  .middleOutLine {
    height: 40.8rem;
    overflow: auto;
    width: 100%;
    padding: 0 10px;
    border-left: 0.5px solid #2ac1ff;
    border-right: 0.5px solid #2ac1ff;
    //  background:rgba(26,49,70,0.3);
    background-color: rgba(15, 36, 69, 0.8);
  }
  .notisfy {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-left: 3%;
    font-size: 12px;
    margin-bottom: 15px;
  }
  .topSpot {
    width: 222px;
    height: 125px;
    background: url("../../../../../../assets/spot.png") no-repeat;
    position: absolute;
    right: 15px;
    top: -62px;
    z-index: 10;
  }
  .bottomSpot {
    width: 222px;
    height: 120px;
    background: url("../../../../../../assets/spot.png") no-repeat;
    // background-size:cover;
    position: absolute;
    left: -35px;
    bottom: -45px;
    z-index: 10;
  }
}
.mapBox {
  width: 96%;
  height: 200px;
  padding: 24px 20px 16px 26px;
  box-sizing: border-box;
  position: relative;
  // margin-left:20px;
  float: right;
}
.coverbg {
  // width: 525px;
  width: 100%;
  height: 274px;
  background: url("../../../../../../assets/mapborder.png") no-repeat;
  background-size: 100%;
  position: absolute;
  left: 0px;
  top: 0px;
}
/deep/.el-image-viewer__wrapper {
  position: fixed;
  top: 10%;
  right: 10%;
  bottom: 10%;
  left: 10%;
}
</style>
